import auth from "./auth";
import common from "./common";
import documents from "./documents";

export default {
  ...auth,
  ...common,
  ...documents,
};
